import { render, staticRenderFns } from "./SoundLibraryModal.vue?vue&type=template&id=64858a62&"
import script from "./SoundLibraryModal.vue?vue&type=script&lang=js&"
export * from "./SoundLibraryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports